import { UseFormReturn } from "react-hook-form";
import { UserFormSchema, UserSchema } from "./schema";
import { UserModel } from "../../../../main/users-facility/api/types";

export interface IUserInvModal {
  onSelectActiveRecord?: (user: UserFormSchema) => void;
  onInviteNew?: (user: UserFormSchema) => void;
  onClose?: () => void;
  onNoResultFound: (user: UserFormSchema) => void;
  formSchema: UseFormReturn<UserSchema>;
  modalTitle?: string;
  formTitle?: string;
  formDescription?: string;
  walkthroughMode?: boolean;
  isInternal?: boolean;
}

export enum UserInvitationType {
  Email,
  UserFullname,
}

export const initialUserData: UserSchema = {
  type: UserInvitationType.Email,
  email: "",
  firstName: "",
  lastName: "",
};

export const userInvitationOptions = [
  {
    label: "Email Address",
    value: UserInvitationType.Email,
    id: "email-option",
  },
  {
    label: "Both Last Name and First Name",
    value: UserInvitationType.UserFullname,
    id: "fullname-option",
  },
];

export type cropModel = {
  x: number;
  y: number;
  width: number;
  height: number;
};

export const getExistingUserError = (
  selectedUser: UserModel | undefined,
  isAddingFromFacility: boolean,
  isAddingFromBizbox: boolean,
  isAddingGroupAdmin: boolean,
  isFacilityUsersModule: boolean = false,
) => {
  if (isAddingFromBizbox) {
    if (selectedUser?.alreadyExistInFacilityUser) {
      return "This email address is already assigned to a Facility Role. Please use a different email address for the Bizbox role.";
    }

    if (selectedUser?.alreadyExistInGroupAdmin) {
      return "This email address is already assigned to a Group Admin or Co-Group Admin. Please use a different email address for the Bizbox role.";
    }
  }
  if (isAddingFromFacility) {
    if (selectedUser?.alreadyExistInCurrentFacility) {
      return "This email address is already assigned to this Facility. Please use a different email address.";
    }

    if (!isFacilityUsersModule && selectedUser?.alreadyExistInFacilityAdmin) {
      return "This email address is already assigned to a Facility Admin or Co-Facility Admin role. Please use a different email address.";
    }

    if (selectedUser?.alreadyExistInBizboxUser) {
      return "This email address is already assigned to a Bizbox Role. Please use a different email address for the Facility role.";
    }

    if (selectedUser?.alreadyExistInGroupAdmin) {
      return "This email address is already assigned to a Group Admin or Co-Group Admin. Please use a different email address for the Facility role.";
    }
  }
  if (isAddingGroupAdmin) {
    if (selectedUser?.alreadyExistInBizboxUser) {
      return "This email address is already assigned to a Bizbox Role. Please use a different email address for the Group Admin/Co-Group Admin.";
    }

    if (selectedUser?.alreadyExistInFacilityUser) {
      return "This email address is already assigned to a Facility Role. Please use a different email address for the Group Admin/Co-Group Admin.";
    }
  }

  return null;
};
